import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useImportLastNeedsStateMutation } from '../../../../hooks/mutations/useActivityMutation';
import { useSitesQuery } from '../../../../hooks/queries/useSitesQuery';
import { useAuth } from '../../../../hooks/useAuth';
import DropDown from '../../../ui/DropDown';
import ModalBody, { ModalProps } from '../../ModalBody';

interface ImportLastNeedsModalProps extends ModalProps {
    refetch?: () => void;
    currentDate: Date;
}

const ImportLastNeedsModal: React.FC<ImportLastNeedsModalProps> = ({ open, handleClose, refetch = () => {}, currentDate }) => {
    const [selectedSite, setSelectedSite] = useState({ label: '', value: '' });
    const { t } = useTranslation();
    const { user } = useAuth();

    const { data: dataSites, isLoading: isSitesLoading } = useSitesQuery({
        queries: { active: true, conducId: user?._id, assistantConducId: user?._id },
    });

    const { mutate: importNeeds, isLoading: isImportNeedsLoading } = useImportLastNeedsStateMutation({ onSettled: refetch, onSuccess: handleClose });

    return (
        <ModalBody
            title={t('activity')}
            subtitle={t('add')}
            open={open}
            handleClose={handleClose}
            onSubmit={() => {
                importNeeds({ siteId: selectedSite.value, date: currentDate.toISOString() });
            }}
            disableSubmit={!selectedSite.value.length}
            submitLoading={isImportNeedsLoading}
        >
            <DropDown
                selectedItem={selectedSite}
                items={dataSites?.map((site) => ({ label: site.name, value: site._id })) || []}
                handleChange={(event, value) => setSelectedSite({ value: value?.value || '', label: value?.label || '' })}
                inputLabel={t('site')}
                loading={isSitesLoading}
                required
            />
        </ModalBody>
    );
};

export default ImportLastNeedsModal;
